import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getModel23 = async (id) => {
    const res = await axios.get(`/api/v1/models23/${id}`);
    return res.data;

}

export const getModels23 = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/models23?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const createModel23 = async (data) => {
    const res = await axios.post(`/api/v1/models23`, data);
    return res.data;
}

export const updateModel23 = async (id, data) => {
    const res = await axios.put(`/api/v1/models23/${id}`, data);
    return res.data;
}

export const deleteModel23 = async (id) => {
    const res = await axios.delete(`/api/v1/models23/${id}`);
    return res.data;

}

export const exportModel23 = async (id, format=null) => {
    const urlParams = createUrlParams({format})
    const res = await axios.get(`/api/v1/models23/${id}/export?${urlParams.toString()}`, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}

export const exportModels23 = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/models23/export?${urlParams.toString()}`;
    const res = await axios.get(url, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}